<template>
  <div class="modal-container">
    <div class="block">
      <detail-header
          :contractShow="true"
          :pcdType="11"
          :formDataObj="proData"
          :isSubmit="isSubmit"
          :isEdit="true"
          @payObj="getPayObj"
          @changeContractType="changeContractType"
          :isLoaded="isLoaded"
          :isHasDo="true"
      ></detail-header>
    </div>
    <create-ele-modal ref="createEleModal" v-if="proData.payType === 1" :proData="proData" :isSubmit="isSubmit"
                      :isSave="isSave" :isCancel="isCancel" @setParams="getParams"></create-ele-modal>
    <create-carriage-contract ref="createCarriageModal" v-else :proData="proData" :isSubmit="isSubmit"
                              :isSave="isSave" :isCancel="isCancel" @setParams="getParams"></create-carriage-contract>
    <div class="footer add-btn-box">
      <Button @click="cancel" style="width: 100px;border-radius: 4px;">取 消</Button>
      <Button style="width: 100px;border-radius: 4px;" @click="saveDraftFlowForContractFadada">保 存</Button>
      <Button type="primary" @click="commit" style="border-radius: 4px;">发起签署流程</Button>
    </div>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import DetailHeader from "@/views/procedure/DetailHeader";
import CreateEleModal from "@/views/contracts/CreateEleModal";
import CreateCarriageContract from "@/views/contracts/CreateCarriageContract";
import {hideLoading, showLoading} from "@/utils/util";


export default {
  name: "CreateModal",
  components: {DetailHeader, CreateEleModal, CreateCarriageContract},
  data() {
    return {
      isInit: false,
      proData: {
        payType: 1
      },
      isLoaded: false,
      isSubmit: false,
      isCancel: false,
      isSave: false,
      isEdit: false,
      isError: false,
      params: {},
      isUpdate: false,
      contractId: null,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      let id = parseInt(this.$route.params.id);
      this.initBySave(id)
    } else {
      this.init();
    }
  },
  methods: {
    commit() {
      this.isSubmit = true;
      setTimeout(async () => {
        this.isSubmit = false;
        if (this.isError) {
          this.$XModal.alert({
            message: '请完善信息',
            status: "error",
          });
          return;
        }
        this.saveFlowForContractFadada();
      }, 1000);
    },
    async saveFlowForContractFadada() {
      this.params.dataType = this.proData.payType;
      if (this.proData.payType === 1) {
        if (this.params.signType === 1) {
          if (this.params.ordContractFadadaExpands.length < 1) {
            this.$XModal.alert({
              message: '单方签署至少添加一个签约方',
              status: "error",
            });
            return
          }
        } else if (this.params.signType === 2) {
          if (this.params.ordContractFadadaExpands.length < 2) {
            this.$XModal.alert({
              message: '双方签署至少添加两个签约方',
              status: "error",
            });
            return
          }
        } else if (this.params.signType === 3) {
          if (this.params.ordContractFadadaExpands.length < 3) {
            this.$XModal.alert({
              message: '多方签署至少添加三个签约方',
              status: "error",
            });
            return
          }
        } else {
          this.$XModal.alert({
            message: '请选择签约方式',
            status: "error",
          });
          return
        }

        let platCompCheck = false, platSignTypeCheck = false, compName = false, perName = false, compNameCheck = false,
            partyPhone = false,
            partyPhoneCheck = false, perNameCheck = false;
        this.params.ordContractFadadaExpands.map(i => {
          i.partyName = i.partyName ? i.partyName.replace('(', '（').replace(')', '）') : i.partyName;
          if (i.partyType === 1 && !i.partyName) {
            platCompCheck = true;
            return
          }
          if (i.partyType === 1 && !i.signatureType) {
            platSignTypeCheck = true;
            return
          }
          if (i.partyType === 2) {
            if (!i.partyName) {
              compName = true;
              return
            }
            let reg = new RegExp(/^[\u4e00-\u9fa5（）]+$/);
            if (i.partyName.length < 8 || i.partyName.length > 30 || !reg.test(i.partyName)) {
              compNameCheck = true;
              return
            }
          }
          if (i.partyType === 3) {
            if (!i.partyName) {
              perName = true;
              return
            }
            let regName = new RegExp(/^[\u4e00-\u9fa5]+$/);
            if (!regName.test(i.partyName) || i.partyName.length < 2 || i.partyName.length > 15) {
              perNameCheck = true;
              return
            }
          }
          if (i.partyType === 2 || i.partyType === 3) {
            if (!i.partyPhone) {
              partyPhone = true;
              return
            }
            if (i.partyPhone.length !== 11) {
              partyPhoneCheck = true;
              return
            }
          }
        })

        if (platCompCheck) {
          this.$XModal.alert({
            message: '请选择平台企业',
            status: "error",
          });
          return
        }
        if (platSignTypeCheck) {
          this.$XModal.alert({
            message: '请选择平台印章类型',
            status: "error",
          });
          return
        }
        if (compName) {
          this.$XModal.alert({
            message: '请输入企业名称',
            status: "error",
          });
          return
        }
        if (perName) {
          this.$XModal.alert({
            message: '请输入个人姓名',
            status: "error",
          });
          return
        }
        if (compNameCheck) {
          this.$XModal.alert({
            message: '企业名称只能输入中文(含括号)位数8-30位',
            status: "error",
          });
          return
        }
        if (perNameCheck) {
          this.$XModal.alert({
            message: '请输入正确的个人姓名',
            status: "error",
          });
          return
        }
        if (partyPhone) {
          this.$XModal.alert({
            message: '请输入绑定手机号',
            status: "error",
          });
          return
        }
        if (partyPhoneCheck) {
          this.$XModal.alert({
            message: '请输入正确的手机号',
            status: "error",
          });
          return
        }

        // if(!this.params.signPlaceData){
        //   this.$XModal.alert({
        //     message: '请设置签署位置',
        //     status: "error",
        //   });
        //   return
        // }
      } else {
        this.params.signType = 2;
        if (!this.params.palletType) {
          this.$XModal.alert({
            message: "请选择托运人信息",
            status: "error"
          });
          return
        }
        if (!this.params.shipperType) {
          this.$XModal.alert({
            message: "请选择承运人信息",
            status: "error"
          });
          return
        }
        if (this.params.palletType === 1) {
          this.params.compName = this.params.palletName;
          this.params.platformCompanyId = this.params.palletId;
          this.params.firstPartyType = 1;
          this.params.firstPartyId = this.params.palletId;
          this.params.firstPartyPhone = this.params.palletPhone;
          this.params.firstPartyName = this.params.palletName;
          this.params.secondPartyType = this.params.shipperType;
          this.params.secondPartyId = this.params.shipperId;
          this.params.secondPartyPhone = this.params.shipperPhone;
          this.params.secondPartyName = this.params.shipperName;
        } else {
          this.params.compName = this.params.shipperName;
          this.params.platformCompanyId = this.params.shipperId;
          this.params.firstPartyType = 1;
          this.params.firstPartyId = this.params.shipperId;
          this.params.firstPartyPhone = this.params.shipperPhone;
          this.params.firstPartyName = this.params.shipperName;
          this.params.secondPartyType = this.params.palletType;
          this.params.secondPartyId = this.params.palletId;
          this.params.secondPartyPhone = this.params.palletPhone;
          this.params.secondPartyName = this.params.palletName;
        }
        if (this.params.beginTime && this.params.palletAddTime) {
          if (this.params.beginTime < this.params.palletAddTime) {
            this.$XModal.alert({
              message: "签约日期需不能大于起运时间",
              status: "error"
            });
            return
          }
        }
        if (this.params.beginTime && this.params.endTime) {
          if (this.params.beginTime > this.params.endTime) {
            this.$XModal.alert({
              message: "到达日期不能早于起运日期",
              status: "error"
            });
            return
          }
        }
      }
      showLoading();
      let res = await $api.flowInstance.request("saveFlowForContractFadada", {
        applyTime: this.$utils.timestamp(this.$utils.toStringDate(this.proData.applyTime)),
        applyUserId: this.proData.applyUserId,
        contractFadada: this.params,
        flowTempletId: 11,
        id: this.initBySaveId ? this.initBySaveId : this.proData.id,
        instanceName: this.proData.instanceName,
        instanceNum: this.proData.instanceNum,
        leaderId: this.proData.leaderId,
        managerId: this.proData.managerId,
        reterenceId: this.proData.reterenceId,
        reterenceName: this.proData.reterence,
        payType: this.proData.payType
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("提交成功，待审批通过后签署");
        if (this.isUpdate) {
          this.delete(this.contractId);
        }
        this.cancel();
      } else {
        if (res.message !== '') {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        } else {
          this.$XModal.alert({
            message: res.data[0].failMsg,
            status: "error",
          });
        }
      }
    },
    async delete(id) {
      let res = await $api.eleContract.request("deleteContractFadada", {
        id: id,
      });
    },
    saveDraftFlowForContractFadada() {
      if (this.proData.payType === 2) {
        this.params.signType = 2;
      }
      this.params.dataType = this.proData.payType;
      this.isSave = true;
      showLoading();
      setTimeout(async () => {
        this.isSave = false;
        let res = await $api.flowInstance.request("saveDraftFlowForContractFadada", {
          applyTime: this.$utils.timestamp(this.$utils.toStringDate(this.proData.applyTime)),
          applyUserId: this.proData.applyUserId,
          contractFadada: this.params,
          flowTempletId: 11,
          id: this.initBySaveId ? this.initBySaveId : null,
          instanceName: this.proData.instanceName,
          instanceNum: this.proData.instanceNum,
          leaderId: this.proData.leaderId,
          managerId: this.proData.managerId,
          reterenceId: this.proData.reterenceId,
          reterenceName: this.proData.reterence,
          payType: this.proData.payType
        });
        hideLoading();
        if (res.status === 1) {
          this.$Message.success("保存成功");
          this.cancel();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      });
    },
    getParams(obj) {
      this.isError = false;
      if (obj) {
        this.params = Object.assign(this.params, obj);
      } else {
        this.isError = true;
      }
    },
    init() {
      this.getFlowData();
      this.$nextTick(() => {
        if (this.$refs.createEleModal) {
          this.$refs.createEleModal.init();
        } else if (this.$refs.createCarriageModal) {
          this.$refs.createCarriageModal.init();
        }

      })
    },
    cancel() {
      this.proData = {
        payType: 1
      };
      this.isLoaded = false;
      this.isCancel = true;
      this.isUpdate = false;
      this.contractId = null;
      window.close();
      setTimeout(() => {
        this.isCancel = false;
      }, 1000);
    },
    getPayObj(val) {
      this.proData = val;
    },
    changeContractType(val) {
      this.proData.payType = val;
      if (val === 1) {
        this.$nextTick(() => {
          this.$refs.createEleModal.init();
        })
      } else {
        this.$nextTick(() => {
          this.$refs.createCarriageModal.init();
        })
      }
    },
    getFlowData() {
      document.title = '新建电子合同';
      let obj = {flowTempletId: 11};
      $api.flowInstance.createFlowModel
          .GET({
            params: obj
          })
          .then(res => {
            if (res.status === 1) {
              res.data.payType = 1;
              this.$set(this, 'proData', res.data)
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                this.close();
              });
            }
          });
    },
    async initBySave(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id
            }
          })
          .then(res => {
            if (res.status === 1) {
              document.title = '编辑电子合同';
              this.proData = Object.assign({}, res.data);
              this.isLoaded = true;
              if (this.proData.payType === 1) {
                this.$nextTick(() => {
                  this.$refs.createEleModal.getContractFadadaTwoList(id);
                })
              } else {
                this.$nextTick(() => {
                  this.$refs.createCarriageModal.getContractPalletDetail(id);
                })
              }
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error"
              });
            }
          });
    },
    setUpdate(id, flowId) {
      this.isUpdate = true;
      this.contractId = id;
      this.initUpdate(flowId);
    },
    async initUpdate(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id
            }
          })
          .then(res => {
            if (res.status === 1) {
              this.proData = Object.assign({}, res.data);
              this.isLoaded = true;
              if (res.data.payType === 1) {
                this.$nextTick(() => {
                  this.$refs.createEleModal.getContractFadadaList(id, 'update');
                })
              } else {
                this.$nextTick(() => {
                  this.$refs.createCarriageModal.getContractPalletDetail(id, 'update');
                })
              }
              this.isLoaded = false;
              this.getUpdateFlowData(res.data.payType);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error"
              });
            }
          });
    },
    getUpdateFlowData(payType) {
      let obj = {flowTempletId: 11};
      $api.flowInstance.createFlowModel
          .GET({
            params: obj
          })
          .then(res => {
            if (res.status === 1) {
              res.data.payType = payType;
              this.$set(this, 'proData', res.data)
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                this.close();
              });
            }
          });
    },
  }
}

</script>
<style scoped>
.modal-container {
  box-sizing: border-box;
  padding: 20px 60px;
  background: #F5F7F9;
}

.block {
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px rgba(211, 211, 211, 0.75);
  padding: 10px;
}

</style>